<div class="cs-segment-row cs-d-flex h-100 pos-rlt" *ngIf="!loading">
    <div class="cs-segment-wrapper h-100 segment-level-1" [style.display]="(!segmentations[0].selected && !segmentations[1].selected) ? 'block':'none'">
        <div class="cs-segment-container h-100" [style.display]="!segmentations[0].selected && !segmentations[1].selected ? 'block':'none'">
            <div class="cs-template-empty-view cs-d-flex flex-column h-100 pos-rlt" >
                <div class="empty-view-icon"><i class="fas fa-exclamation-triangle"></i></div>
                <div class="bold" translate>no.segmentation.set.up</div>
                <div translate>you.can.choose.to.segment.your.invoice</div>
                <a (click)="openSidepanel()" translate>set.up.segmentation</a>
            </div>

        </div>
    </div>
    <div *ngFor="let segmentation of segmentations; index as i">
        <div class="cs-segment-wrapper h-100 segment-level-1" [style.display]="segmentation.selected ? 'block':'none'" >
            <div class="cs-segment-container h-100" [style.display]="segmentation.selected ? 'block':'none'">
                <div class="seg-header">
                    <!--<div class="ph-item height-100" [style.padding-left]="0" [style.padding-right]="0">
                        <div class="ph-col-12 height-100" [style.padding-left]="0" [style.padding-right]="0">
                            <div class="ph-row align-items-center">
                                <div class="ph-col-8 mb3"></div>
                            </div>
                        </div>
                    </div>-->
                    <div class="seg-title-section">
                        <h4> {{convertToTitleCase(segmentation.categoryName)}}</h4>
                        <div *ngIf="(i == 0 && !inputModel.settings.readOnly) || ( i == 1 && opportunityScreen && secondarySegmentation && segmentationEditAccess)" class="seg-actions ml-auto pr-10">
                            <a (click)="openSidepanel()" class="mr-5">Edit</a>
                            <a (click)="deleteSegment(i)">Delete</a>
                        </div>
                    </div>
                    <div class="seg-filter-section">
                        <div class="cs-search_box cs-d-flex align-items-center">
                            <span><i class="fa-solid fa-magnifying-glass cs--placeholder-color"></i></span>
                            <input type="text" placeholder="Search {{convertToTitleCase(segmentation.categoryName,'placeholder') | strReplace:'_':' '}}" [(ngModel)]="segmentation.searchText" (keyup)="onSegLineItemSearch(i)"/>
                            <span class="clear-input" [ngStyle]="{visibility: (!segmentation.searchText.length)? 'hidden': 'visible'}" (click)="segmentation.searchText = '';onSegLineItemSearch(i)"><i class="fa fa-times-circle" aria-hidden="true"></i></span>
                        </div>
                    </div>
                </div>

                <div class="seb-body cs-flex-1">
                    <div class="seg-list-section" *ngIf="segmentation.process == 'loaded'">
                        <ul>
                            <li class="seg-item" [style.background]="-1 === segmentation.activeItem ? '#DAFDD7':''">
                                <div class="cs-d-flex" (click)="segmentSelection(i,-1); $event.stopPropagation()">
                                    <div class="text-truncate text-width">{{'Any'}}</div>
                                    <div class="icon-display">
                                        <div class="seg-clone-item" *ngIf="optionFullFilled && -1 === segmentation.activeItem" (click)="onCloneClick(i, -1)"><i class="fas fa-clone"></i></div>
                                        <div class="seg-check-item" *ngIf="optionFullFilled && -1 === segmentation.activeItem || (-1 !== segmentation.activeItem && segmentation.AnySeleted)"><i class="fas fa-check-circle"></i></div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <ul *ngFor="let row of segmentation.listItemsFiltered">
                            <li class="seg-item" [style.background]="row.id === segmentation.activeItem ? '#DAFDD7':''">
                                <div class="cs-d-flex" (click)="segmentSelection(i,row.id)">
                                    <div class="text-truncate text-width">{{row.text}}</div>
                                    <div class="icon-display">
                                        <div class="seg-clone-item" *ngIf="(row.id == segmentation.activeItem && optionFullFilled)" (click)="onCloneClick(i, row.id)"><i class="fas fa-clone"></i></div>
                                        <div class="seg-check-item" *ngIf="(optionFullFilled && row.id === segmentation.activeItem) || (row.id !== segmentation.activeItem && row.selected)"><i class="fas fa-check-circle"></i></div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div *ngIf="segmentation.process == 'loading' || segmentation.process == 'load_error'">
                        <ul *ngFor="let line of [1,2,3,5,6,7]" class="line-item">
                            <li class="seg-item">
                                <div class="text-layout animated-background long"></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!--
<div class="cs-segment-row cs-d-flex h-100 pos-rlt">
    <div class="cs-segment-wrapper h-100 segment-level-1">
        <div class="cs-segment-container h-100">
            <div class="seg-header">
                <div class="seg-title-section">
                    <h4>Title Segmentation</h4>
                    <div class="seg-actions ml-auto pr-10">
                        <a href="" class="mr-5">Edit</a>
                        <a href="">Delete</a>
                    </div>
                </div>
                <div class="seg-filter-section">
                    <div class="cs-search_box cs-d-flex align-items-center">
                        <span><i class="fal fa-search"></i></span>
                        <input type="text" placeholder="Search" />
                    </div>
                </div>
            </div>

            <div class="seb-body cs-flex-1">
                <div class="seg-list-section">
                    <ul>
                        <li class="seg-item">
                            <div class="cs-d-flex">
                                <div class="text-truncate">All</div>
        &lt;!&ndash;                        <div class="seg-clone-item"><i class="fas fa-clone"></i></div>&ndash;&gt;
                                <div class="seg-check-item"><i class="fas fa-check-circle"></i></div>
                            </div>
                        </li>
                        <li class="actives">
                            <div class="cs-d-flex">
                                <div class="text-truncate">Deposit</div>
                                &lt;!&ndash;<div class="seg-clone-item"><i class="fas fa-clone"></i></div>
                                <div class="seg-check-item"><i class="fas fa-check-circle"></i></div>&ndash;&gt;
                            </div>
                        </li>
                        <li>
                            <div class="cs-d-flex">
                                <div class="text-truncate">Additional</div>
                                &lt;!&ndash;<div class="seg-clone-item"><i class="fas fa-clone"></i></div>
                                <div class="seg-check-item"><i class="fas fa-check-circle"></i></div>&ndash;&gt;
                            </div>
                        </li>
                        <li class="actives">
                            <div class="cs-d-flex">
                                <div class="text-truncate">Deposit</div>
                                <div class="seg-clone-item"><i class="fas fa-clone"></i></div>
                                <div class="seg-check-item"><i class="fas fa-check-circle"></i></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="cs-segment-wrapper h-100 segment-level-2">
        <div class="cs-segment-container h-100">
            <div class="seg-header">
                <div class="seg-title-section">
                    <h4>Title Segmentation</h4>
                    <div class="seg-actions ml-auto pr-10">
                        <a href="" class="mr-5">Edit</a>
                        <a href="">Delete</a>
                    </div>
                </div>
                <div class="seg-filter-section">
                    <div class="cs-search_box cs-d-flex align-items-center">
                        <span><i class="fal fa-search"></i></span>
                        <input type="text" placeholder="Search" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
-->
<ng-template #right_panel>
    <form *ngIf="segmentationSetupForm" [formGroup]="segmentationSetupForm" class="cs-sidepanel-form slim-scroll thin">
        <!-- Panel title -->
        <div class="modal-header">
            <h4 class="modal-title pull-left" translate>set.up.segmentation</h4>
        </div>
        <!-- Segmentation level 1 -->

        <!-- Panel help text -->

        <div class="modal-body" [appCsScrollbar]>
            <!--<div class="help_section">
                <p translate>select.the.relevant.segmentation.below.in.order.to.identify</p>
            </div>-->
            <div class="body-content-section">
                <!-- Panel content -->
                <div class="row-fluid-wrapper">
                    <div class="control-group">
                        <label class="control-label required_field" translate="">Con.Primary.segmentation</label>
                        <div class="controls required-block">
                            <select (change)="checkSegmentation($event)" formControlName="segmentation_1"
                                    class="full-width-select">
                                <option value=""> ----- Please select ------</option>
                                <option *ngFor="let option of possibleSegCategories" [value]="option['value']">{{convertToTitleCase(option['value'])}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row-fluid-wrapper" *ngIf="(opportunityScreen && secondarySegmentation) || !opportunityScreen">
                    <div class="control-group">
                        <label class="control-label" translate>Con.Secondary.segmentation</label>
                        <div class="controls">
                            <select formControlName="segmentation_2" id="secondarySegment"
                                    [attr.disabled]="segmentationSetupForm.controls['segmentation_1'].value == ''? true: null"
                                    class="full-width-select">
                                <option value=""> ----- Please select ------</option>
                                <option *ngFor="let option of possibleSeg2Categories" [value]="option['value']">{{convertToTitleCase(option['value'])}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Panel actions -->
        <div class="modal-footer">
            <a [hidden]="segmentationSetupSaving" (click)="onSidepanelClose()" class="btn" id="cancel-panel-btn" href="javascript: void(0)" translate>Cancel</a>
            <button (click)="openLabourTab()" [ngClass]="{'loading': segmentationSetupSaving}" [disabled]="segmentationSetupSaving || segmentationSetupForm.invalid || segmentationSetupForm.controls.segmentation_1.value=='no_segmentation'" type="button"
                    class="btn btn-primary">
                <span translate>Save</span>
            </button>
        </div>
    </form>
</ng-template>

<cs-modal #allocationCloneModal *ngIf="cloneAllocationsForm" [formGroup]="cloneAllocationsForm"
          (onClose)="onCloneModalClose()">
    <ng-container *ngIf="cloneAllocationsModalIsOpen">

        <!-- Modal header -->
        <div class="modal-header">
            <button type="button" class="close" (click)="cloneAllocationsModal?.close()">×</button>
            <h4 translate>con.labour.contract.clone.title</h4>
        </div>

        <!-- Help text-->
        <!--<div class="help_section">
          <p i18n="@@ct96">Apply your setup to other segments</p>
        </div>-->

        <!-- Modal body -->
        <div class="modal-body ">
            <div class="row-fluid small-padding">
         <span>
           <p translate>con.labour.travel.clone.help.text</p>
           <p translate>con.labour.travel.cost.clone.label</p>
         </span>
                <div class="required-block">
                    <input type="text" csSelect2 [select2Config]="cloneAllocationsSelect2Config"
                           (selected)="onCloneTargetSegmentSelect($event)"/>

                    <validation-error [formGroup]="cloneAllocationsForm" controlName="targetValues">
                        <span translate [translateParams]="{message: 'one or more segments'}">select.help.text</span>
                    </validation-error>
                </div>
            </div>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer">
            <a href="javascript:void(0)" class="btn btn-cancel"
               (click)="cloneAllocationsModal.close()" translate>Cancel</a>

            <button (click)="cloneAllocations()"  type="button"
                    class="btn btn-primary primary-button">
                <span translate>Clone</span>
            </button>
        </div>
    </ng-container>
</cs-modal>

